export default "__VITE_ASSET__RSFsOzZB__"